import React, { Component } from 'react';
import DataTable from '../../../Elements/DataTable/DataTableFigma';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import PricingDetailService from '../../../Services/PricingDetailService';
import Loading from '../../../Elements/loading';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import VPricingDetailListTotalItem from '../../../Domain/VPricingDetailListTotalItem';
import PricingService from '../../../Services/PricingService';
import ErrorMessage from '../../../Elements/ErrorMessage';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import PricingDetailCountrySelector from './PricingDetailCountrySelector';

class PricingDetailAdminList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pricingDetail: [],
      selectedItem: {},
      shownPanel: ShownPanelsEnum.None,
    };
    VPricingDetailListTotalItem.clickOnSelect = this.clickOnSelect.bind(this);
  }

  componentDidMount() {
    this.populatePricingDetailList();
  }

  clickOnSelect(item, selected) {
    item.Selected = selected;
    const templist = [...this.state.pricingDetail];
    templist.find((c) => c.PricingDetailId === item.PricingDetailId).Selected = selected;
    this.setState({
      pricingDetail: templist,
    });
  }

  populatePricingDetailList(clearCache = false) {
    this.setState({ loading: true });
    PricingDetailService.GetPricingDetailListTotals(this.props.PricingId, clearCache)
      .then((result) => {
        this.setState({
          pricingDetail: PricingDetailService.ConvertPricingDetailListTotalsItem(result),
          loading: false,
        });
      })
      .catch(() => ErrorMessage.SetErrorMessage('PDAL52'));
  }

  UseSelectedPricingDetail = () => {
    this.setState({ loading: true });
    const list = this.state.pricingDetail.filter((x) => x.Selected === true);
    const data = {
      Action: 'UseSelectedPricingDetail',
      PricingDetailId: list[0].PricingDetailId,
      PricingId: list[0].PricingId,
    };
    PricingService.MultiplePost(data)
      .then((result) => {
        this.populatePricingDetailList();
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('PDAL68');
        this.setState({ loading: false });
      });
  };

  CopyPricingDetail = () => {
    this.setState({ loading: true });

    PricingDetailService.CopyPricingDetail(this.props.PricingId)
      .then((result) => {
        if (result && result.error) {
          ErrorMessage.SetErrorMessage(result.error);
        }
        this.populatePricingDetailList();
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('PDAL68');
        this.setState({ loading: false });
      });
  };

  onCopyButtonClick() {
    const selectedItem = this.state.pricingDetail.find((c) => c.Selected === true);
    this.setState({ shownPanel: ShownPanelsEnum.Copy, selectedItem });
  }

  renderOnePanel(panelId, content) {
    return this.state.shownPanel === panelId ? content : null;
  }

  renderButtonsAndPanels() {
    const UseSelected = this.state.pricingDetail.filter((c) => c.Selected === true).length !== 1;

    return (
      <>
        <FigmaButtonRow
          buttons={[
            {
              tooltip: 'Copy Pricing',
              type: ButtonTypeEnum.NormalIconOnly,
              color: ButtonColorsEnum.Primary,
              iconPosition: IconPositionEnum.Center,
              disabled: this.state.pricingDetail.filter((c) => c.Selected === true).length !== 1 || this.props.Status,
              iconName: 'fa-solid fa-copy',
              onClick: () => this.onCopyButtonClick(),
              roleKey: 'opportunity_edit',
            },
            {
              tooltip: 'Use Selected Version',
              type: ButtonTypeEnum.NormalIconOnly,
              color: ButtonColorsEnum.Common,
              iconPosition: IconPositionEnum.Center,
              disabled: UseSelected || this.props.Status,
              iconName: 'fa-regular fa-circle-check',
              onClick: () =>
                ErrorMessage.SetApprove('You will change the active version.', () => this.UseSelectedPricingDetail()),
            },
            {
              iconName: 'fa-solid fa-refresh',
              type: ButtonTypeEnum.NormalIconOnly,
              tooltip: 'Refresh',
              color: ButtonColorsEnum.Common,
              iconPosition: IconPositionEnum.Center,
              onClick: () => this.populatePricingDetailList(true),
            },
            {
              iconName: 'fa-solid fa-plus-circle',
              type: ButtonTypeEnum.NormalIconOnly,
              color: ButtonColorsEnum.Primary,
              iconPosition: IconPositionEnum.Center,
              tooltip: 'Copy active version',
              disabled: this.props.Status,
              onClick: () =>
                ErrorMessage.SetApprove('You will create a new pricing version from the active version.', () =>
                  this.CopyPricingDetail()
                ),
              roleKey: 'opportunity_edit',
            },
          ]}
        />
        {this.renderPanels()}
      </>
    );
  }

  renderPanels() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.Copy,
          <PricingDetailCountrySelector
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            pricingDetailId={this.state.selectedItem.PricingDetailId}
          />
        )}
      </div>
    );
  }

  render() {
    if (this.state.loading) return <Loading />;

    return (
      <div className='contentwrapper'>
        {this.renderButtonsAndPanels()}
        <div className='StaticDataTable'>
          <DataTable
            itemList={this.state.pricingDetail}
            type={VPricingDetailListTotalItem}
            popupEnabled={true}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
          />
        </div>
      </div>
    );
  }
}

export default PricingDetailAdminList;
